export const SET_TASK_PROMPT = 'SET_TASK_PROMPT';
export const SET_IS_WHITELISTED = 'SET_IS_WHITELISTED';
export const SET_EMBEDDED_WALLET = 'SET_EMBEDDED_WALLET';
export const SET_USER = 'SET_USER';
export const SET_AUTH_LOADING = 'SET_AUTH_LOADING';
